export default "__VITE_ASSET__2137182d__"